import React from 'react';

import type { WidgetState } from '../state/store';

export interface StatusViewProps {
  state: WidgetState;
}

const ERROR_HINTS: Record<string, string> = {
  mic_denied: 'El micrófono está bloqueado. Permítelo en la configuración del navegador para hacer y recibir llamadas.',
  mic_unsupported: 'Este navegador no soporta WebRTC. Usa Chrome, Edge o Firefox actualizado.',
  sip_disconnected: 'Perdimos la conexión con el servidor de voz. Reintentando…',
  sip_register_failed: 'No pudimos registrar tu extensión SIP. Contacta al administrador.',
  ice_failed: 'La calidad de la red es baja. Intenta renegociar o cambiar de red.',
  unmapped: 'Tu usuario no está mapeado a una extensión SIP. Avisa al administrador del tenant.',
  invalid_signature: 'Sesión inválida. Recarga Zoho Desk para volver a autenticarte.',
  tenant_not_found: 'Tu organización no está vinculada a Kunzite. Completa el flujo de instalación.',
  tenant_suspended: 'Tu cuenta de Kunzite está suspendida. Contacta a soporte.',
};

export function StatusView({ state }: StatusViewProps): React.JSX.Element {
  if (state.status === 'error' && state.error) {
    const hint = ERROR_HINTS[state.error.code] ?? state.error.message;
    return (
      <section role="alert">
        <strong>Error: {state.error.code}</strong>
        <p>{hint}</p>
        <button onClick={state.reset}>Reintentar</button>
      </section>
    );
  }
  if (state.status === 'ready' && state.session) {
    return (
      <section>
        <strong>Conectado</strong>
        <div>Extensión: {state.session.sipExtension}</div>
        <div>Dominio SIP: {state.session.sipDomain}</div>
      </section>
    );
  }
  if (state.status === 'registering' && state.session) {
    return <p>Registrando extensión {state.session.sipExtension}…</p>;
  }
  if (state.status === 'authenticating') {
    return <p>Autenticando contra Kunzite…</p>;
  }
  return <p>Iniciando…</p>;
}
